module.exports = __webpack_public_path__ + "static/media/isr.860ce028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/isr.jpg
// module id = 200
// module chunks = 0